import React, {useEffect, useState} from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import "react-toastify/dist/ReactToastify.css";
import Button from "react-bootstrap/Button";
import RightModal from "./modalForm";
import '../../../i18/config';
import {useTranslation} from "react-i18next";
import {useHistory, useRedux, useSearchInput} from "../../../hooks";

import {
    editDataContentQuickAnswer,
    getContentQuickAnswers,
    onRemoveContentQuickAnswer,
    removeContentQuickAnswerModalHide,
    removeContentQuickAnswerModalShow,
    showRightModalContentQuickAnswer
} from "../../../redux/actions";

import TableList from "../../../components/TableList";
import ContentQuickAnswerColumns from "./tableColumns";
import {EntityActionsHandlersType} from "../../../redux/types";
import RemoveModal from "../../../components/RemoveForm";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import {HistoryHashType, PAGINATION_DEFAULT_ITEMS_PER_PAGE} from "../../../data/settings";
import Loader from "../../../components/Loader";
import {ContentQuickAnswerType} from "../../../redux/Content/QuickAnswer/types";
import MainListFilter from "../../../components/MainListFilter";

const QuickAnswerIndex = () => {
    const { dispatch, useAppSelector } = useRedux();
    const { t } = useTranslation(['common']);

    const componentType = 'contentQuickAnswerTable';

    const {
        historyHash,
        searchPhrase,
        loadItems,
        handleSearchClick
    } = useHistory({
        componentType,
        loadAction: getContentQuickAnswers,
        dispatch
    });

    const { onSearchInput } = useSearchInput(handleSearchClick);

    const [perPage, setPerPage] = useState(PAGINATION_DEFAULT_ITEMS_PER_PAGE);

    const {
        contentQuickAnswer,
        isFetched
    } = useAppSelector(state => ({
        contentQuickAnswer: state.ContentQuickAnswer,
        isFetched: state.ContentQuickAnswer.isFetched
    }));

    useEffect(() => {
        if (contentQuickAnswer.isNeedReload){
            loadItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, contentQuickAnswer.isNeedReload]);

    const openRightModal = (event:any) => {
        if ((event !== undefined) && (event?.uuid && event.uuid.length>0)){
            dispatch(editDataContentQuickAnswer({data:event, modalEditTitle: 'changeQuickAnswer'}));
        } else {
            dispatch(showRightModalContentQuickAnswer({data:[], modalEditTitle: 'newQuickAnswer'}));
        }
    };

    const onEntityRemoveModalShow = (event:any) => {
        if ((event !== undefined) && (event?.uuid && event.uuid.length>0)){
            dispatch(removeContentQuickAnswerModalShow({data:event, modalEditTitle: 'deleteQuickAnswer'}));
        }
    };

    const onEntityRemoveModalHide = () => dispatch(removeContentQuickAnswerModalHide());

    const onEntityRemove = (event:any) => {
        if ((event !== undefined) && (event?.uuid && event.uuid.length>0)){
            dispatch(onRemoveContentQuickAnswer({data:event, modalEditTitle: 'deleteQuickAnswer'}));
        }
    };

    const EntityActionsHandlers:EntityActionsHandlersType = {
        onEdit: openRightModal,
        onRemove: onEntityRemoveModalShow
    }

    const onTableRowClick = (item:ContentQuickAnswerType) => {
        if (item.actions && item.actions.canEdit){
            openRightModal(item);
        }
    }

    const columns = ContentQuickAnswerColumns(EntityActionsHandlers);

    return (
        <>
            <BreadCrumb title={t('menu:quickAnswers')} pageTitle={t('menu:main')} />
                <Row className="g-4 mb-3">
                    <div className="col-sm-auto">
                        <div>
                            <Button variant="secondary" onClick={openRightModal} className="btn btn-success">
                                <i className="ri-add-line align-bottom me-1"/> {t('common:addNew')}
                            </Button>
                        </div>
                    </div>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="border-bottom-0">
                                <h5 className="card-title mb-0">{t('quickAnswer:myQuickAnswers')}</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">
                                <MainListFilter
                                    onClick={handleSearchClick}
                                    value={searchPhrase}
                                    onChange={onSearchInput}
                                />
                            </CardBody>
                            <CardBody>
                                {isFetched ?
                                    <TableList
                                        columns={columns}
                                        data={contentQuickAnswer.items}
                                        onRowClick={onTableRowClick}
                                        key={componentType}
                                        historyHash = {historyHash}
                                        paginationTotalRows={contentQuickAnswer?.meta?.totalCount || 0}
                                        paginationServer={true}
                                        isShowChangePageSize={true}
                                    />
                                    :
                                    <Loader/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <RightModal/>
                <RemoveModal
                    onRemove={onEntityRemove}
                    handleClose={onEntityRemoveModalHide}
                    removeItem={contentQuickAnswer.selectedItem}
                    isOpen={contentQuickAnswer.removeModalShow}
                    modalTitle={contentQuickAnswer.modalEditTitle}/>
        </>
    );
};

export default QuickAnswerIndex;


